// When global auto_scheduling is enabled, the timedProjectBar layer (manual project rows)
// should use the same renderer as taskBar instead of planned/actual split bars.
// Implemented by wrapping gantt.$ui.layers.timedProjectBar — no Timeline.prototype changes.

export function manualParentTaskBarLayersPatch(instance) {
  if (instance._manualProjectTimedLayerWrapped) {
    return;
  }
  instance._manualProjectTimedLayerWrapped = true;
  const layers = instance.$ui.layers;
  const originalTimedProjectBar = layers.timedProjectBar;
  layers.timedProjectBar = function wrappedTimedProjectBar() {
    if (instance.config.auto_scheduling.enabled) {
      return layers.taskBar();
    }
    return originalTimedProjectBar.call(layers);
  };
}
